import type {Optional} from '@logistics-frontend/types'
import {isFilled} from '@logistics-frontend/utils'

import type {PointAddress} from 'src/shared/types'

export function modifyPointAddressComment(pointAddress: Optional<PointAddress>): Optional<PointAddress> {
  if (pointAddress === undefined) {
    return undefined
  }

  const {_comment, comment, ...otherPoint} = pointAddress
  const newComment = [comment, _comment].filter(isFilled).join('')

  return {
    ...otherPoint,
    comment: newComment,
  }
}
